import React, { useState } from 'react';
import { AccordionItem } from './components/Accordion';
import { Countdown } from './components/Countdown';
import { ComparisonTable, PopUp } from './components/ComparisonTable';
import { Testimonials } from './components/Testimonials';
import { Settings, CheckCircle2, AlertTriangle, ChevronRight, ShieldCheck, Zap, BookOpen } from 'lucide-react';
export function App() {
  const [openModule, setOpenModule] = useState<number | null>(null);
  const [openBonus, setOpenBonus] = useState<number | null>(null);
  const checkoutLink = 'https://checkout.ebookpoint.shop/cart/59704206262353:1';
  const toggleModule = (index: number) => {
    setOpenModule(openModule === index ? null : index);
  };
  const toggleBonus = (index: number) => {
    setOpenBonus(openBonus === index ? null : index);
  };
  const problems = ['Entran a la cancha sin un plan claro y terminan improvisando cada punto.', 'Sufren dolores constantes de codo, hombro o rodilla que los obligan a parar.', 'Se frustran al jugar contra zurdos porque no saben cómo pararse ni dónde jugarles.', 'Pierden partidos ganables por falta de físico o desconcentración en los momentos clave.', 'Gastan fortunas en paletas nuevas creyendo que ahí está la solución a sus errores.'];
  const modules = [{
    title: '🎾 BLOQUE 1 — PADEL SMART PRO',
    content: ['Juego, táctica y estrategia']
  }, {
    title: '📘 TOMO 1 — Los Fundamentos del Jugador Inteligente',
    content: ['Por qué la mayoría de los jugadores se estanca', 'Los errores que arruinan tu progreso', 'Cómo mejorar más rápido', 'Principios del pádel moderno', 'Hábitos de los jugadores que progresan', 'Construcción de una identidad de juego']
  }, {
    title: '📘 TOMO 2 — Posicionamiento y Movimiento',
    content: ['Dónde estar en cada situación', 'Recuperación después del golpe', 'Coberturas', 'Movimiento eficiente', 'Cómo gastar menos energía', 'Errores de desplazamiento']
  }, {
    title: '📘 TOMO 3 — Táctica y Construcción de Puntos',
    content: ['Cómo pensar el partido', 'Construcción del punto', 'Cambios de ritmo', 'Cambios de dirección', 'Dominio del medio', 'Cómo dejar de improvisar']
  }, {
    title: '📘 TOMO 4 — El Jugador Incómodo',
    content: ['Cómo generar errores', 'Juego al cuerpo', 'Cómo romper timing', 'Cómo frustrar rivales', 'Patrones tácticos profesionales', 'Cómo ser impredecible']
  }, {
    title: '📘 TOMO 5 — Mentalidad Competitiva',
    content: ['Gestión emocional', 'Cómo jugar bajo presión', 'Tie-breaks', 'Confianza', 'Rutinas pre partido', 'Control de errores']
  }, {
    title: '📘 TOMO 6 — Sistema de Competencia',
    content: ['Preparación pre partido', 'Adaptación táctica', 'Análisis post partido', 'Corrección de errores', 'Plan de mejora continua', 'Gestión de torneos']
  }, {
    title: '🎾 BLOQUE 2 — PADEL PARA ZURDOS',
    content: []
  }, {
    title: '📘 TOMO 7 — La Identidad del Jugador Zurdo',
    content: ['Por qué el zurdo genera problemas', 'Ventajas reales vs mitos', 'Los errores que desperdician la zurda', 'Cómo construir una identidad táctica', 'Los principios del zurdo inteligente']
  }, {
    title: '📘 TOMO 8 — Dominio del Medio',
    content: ['Qué es dominar el medio', 'Cuándo ocuparlo', 'Cuándo cederlo', 'Cómo generar superioridad táctica', 'Ejercicios específicos', 'Casos reales']
  }, {
    title: '📘 TOMO 9 — Ángulos, Trayectorias y Patrones',
    content: ['Ángulos exclusivos del zurdo', 'Cómo abrir espacios', 'Cómo cerrar puntos', 'Patrones ofensivos', 'Patrones defensivos', 'Jugadas de presión']
  }, {
    title: '📘 TOMO 10 — Cómo Volver Incómodo al Rival',
    content: ['Romper timing', 'Cambios de ritmo', 'Juego al cuerpo', 'Cómo generar errores', 'Manipulación de espacios', 'Presión táctica constante']
  }, {
    title: '📘 TOMO 11 — Táctica Avanzada para Zurdos',
    content: ['Lectura rival', 'Construcción del punto', 'Pareja zurdo-diestro', 'Cómo jugar contra zurdos', 'Cómo jugar contra pegadores', 'Dominio de la red']
  }, {
    title: '📘 TOMO 12 — Sistema de Competencia para Zurdos',
    content: ['Adaptación táctica', 'Gestión emocional', 'Preparación mental', 'Análisis rival', 'Corrección de errores', 'Plan de mejora continua']
  }, {
    title: '🏥 BLOQUE 3 — PREVENCIÓN Y RECUPERACIÓN DE LESIONES',
    content: []
  }, {
    title: '📘 TOMO 13 — Codo Sin Dolor',
    content: ['Epicondilitis en pádel', 'Síntomas tempranos', 'Protocolo de descarga', 'Fortalecimiento excéntrico', 'Técnica y equipamiento', 'Retorno seguro']
  }, {
    title: '📘 TOMO 14 — Hombro Blindado',
    content: ['Pinzamiento y manguito rotador', 'Señales de alarma', 'Movilidad escapular', 'Fortalecimiento específico', 'Ajustes técnicos', 'Reinserción progresiva']
  }, {
    title: '📘 TOMO 15 — Rodillas a Pleno',
    content: ['Tendinitis rotuliana', 'Condromalacia', 'Fortalecimiento seguro', 'Propiocepción', 'Calzado y superficie', 'Retorno al juego']
  }, {
    title: '📘 TOMO 16 — Tobillos Estables',
    content: ['Esguinces', 'Prevención de recaídas', 'Propiocepción', 'Fortalecimiento', 'Taping', 'Desplazamientos explosivos']
  }, {
    title: '💪 BLOQUE 4 — RENDIMIENTO ESPECÍFICO PARA PÁDEL',
    content: []
  }, {
    title: '📘 TOMO 17 — Footwork de Élite',
    content: ['Split step', 'Anticipación', 'Agilidad', 'Transición ataque-defensa', 'Errores posicionales', 'Plan de 4 semanas']
  }, {
    title: '📘 TOMO 18 — Fuerza Específica para Pádel',
    content: ['Potencia para arrancar y frenar', 'Fuerza rotacional', 'Core', 'Tren superior', 'Periodización', 'Plan de 8 semanas']
  }, {
    title: '📘 TOMO 19 — Coordinación y Reacción',
    content: ['Coordinación óculo-manual', 'Reacción a estímulos', 'Lectura de trayectorias', 'Trabajo con pared', 'Bajo fatiga', 'Rutina integrada']
  }, {
    title: '📘 TOMO 20 — Resistencia de Partido',
    content: ['Demanda energética real', 'Trabajo aeróbico', 'HIIT específico', 'Hidratación', 'Nutrición', 'Gestión mental de la fatiga']
  }];
  const bonuses = [{
    title: '🎁 BONO 1: 30 JUGADAS QUE GANAN PARTIDOS',
    content: ['Aperturas', 'Ataque', 'Defensa', 'Dominio del medio', 'Cierre de puntos']
  }, {
    title: '🎁 BONO 2: MANUAL ANTI-RIVALES',
    content: ['Contra pegadores', 'Contra defensivos', 'Contra rápidos', 'Contra zurdos', 'Contra parejas desordenadas']
  }, {
    title: '🎁 BONO 3: PLAN PRO 90 DÍAS',
    content: ['Nivel Aficionado', 'Nivel Intermedio', 'Nivel Avanzado', 'Evaluaciones', 'Objetivos', 'Seguimiento', 'Plan semanal']
  }, {
    title: '🎁 BONO 4: CALCULADORA DE PROTEÍNAS E HIDRATACIÓN',
    content: ['Peso corporal', 'Duración del partido', 'Temperatura', 'Recomendaciones automáticas']
  }, {
    title: '🎁 BONO 5: TABLA DE SUPLEMENTOS CON RESPALDO CIENTÍFICO',
    content: ['Creatina', 'Cafeína', 'Proteína', 'Electrolitos', 'Beta-Alanina', 'Evidencia científica', 'Cuándo usarlos', 'Cuándo no valen la pena']
  }];
  const objections = [{
    q: '¿Es un libro físico o digital?',
    a: 'Es un producto 100% digital en formato PDF. Podrás descargarlo y leerlo en tu celular, tablet o computadora inmediatamente después de la compra.'
  }, {
    q: '¿Sirve si recién empiezo a jugar?',
    a: 'Totalmente. El sistema está diseñado paso a paso. Si sos principiante, te ahorrarás años de frustración y malos hábitos aprendiendo las bases correctas desde el día 1.'
  }, {
    q: '¿Cómo accedo al material una vez que pago?',
    a: 'Una vez procesado el pago, recibirás un correo electrónico de forma automática con el enlace directo para descargar todo el material y los bonos.'
  }, {
    q: '¿Es seguro pagar online?',
    a: 'Sí, utilizamos una plataforma de pagos internacional con encriptación de grado bancario. Tus datos están 100% seguros y protegidos.'
  }];
  const scrollToBuy = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  // Used in the final purchase section — navigates to checkout.
  const BuyButton = ({
    className = ''
  }) => <a href={checkoutLink} className={`block w-full max-w-md mx-auto bg-[var(--pd-green)] hover:bg-[var(--pd-green-dark)] text-black font-black text-base sm:text-xl md:text-2xl py-4 sm:py-5 px-5 sm:px-8 rounded-xl text-center uppercase tracking-wide transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(158,255,0,0.3)] ${className}`} data-id="element-0">
      Quiero ir al siguiente nivel{' '}
      <ChevronRight className="inline-block w-5 h-5 sm:w-6 sm:h-6 ml-1 sm:ml-2 -mt-1" data-id="element-1" />
    </a>;
  // Used everywhere else — smooth-scrolls to the purchase section.
  const ScrollButton = ({
    className = ''
  }) => <button type="button" onClick={scrollToBuy} className={`block w-full max-w-md mx-auto bg-[var(--pd-green)] hover:bg-[var(--pd-green-dark)] text-black font-black text-base sm:text-xl md:text-2xl py-4 sm:py-5 px-5 sm:px-8 rounded-xl text-center uppercase tracking-wide transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(158,255,0,0.3)] ${className}`} data-id="element-2">
      Quiero ir al siguiente nivel{' '}
      <ChevronRight className="inline-block w-5 h-5 sm:w-6 sm:h-6 ml-1 sm:ml-2 -mt-1" data-id="element-3" />
    </button>;
  return <div className="min-h-screen bg-black text-white selection:bg-[var(--pd-green)] selection:text-black pb-24 md:pb-20" data-id="element-4">
      <PopUp data-id="element-5" />

      {/* STICKY MOBILE CTA */}
      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-black/90 backdrop-blur border-t border-zinc-800 p-3" data-id="element-6">
        <div className="flex items-center justify-between gap-3" data-id="element-7">
          <div className="leading-tight" data-id="element-8">
            <span className="block text-zinc-500 line-through text-xs" data-id="element-9">
              $82,990.00
            </span>
            <span className="block text-[var(--pd-green)] font-black text-lg" data-id="element-10">
              $23,990
            </span>
          </div>
          <button type="button" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} className="flex-1 bg-[var(--pd-green)] hover:bg-[var(--pd-green-dark)] text-black font-black text-sm py-3 px-4 rounded-lg uppercase tracking-wide text-center transition-colors" data-id="element-11">
            Lo quiero ahora
          </button>
        </div>
      </div>

      {/* HEADER / HERO */}
      <header className="pt-8 md:pt-12 pb-8 px-4 max-w-5xl mx-auto text-center" data-id="element-12">
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-display font-black text-white uppercase leading-[1.1] mb-6 md:mb-8 tracking-tight" data-id="element-13">
          DEJÁ DE ADIVINAR QUÉ TE FALTA{' '}
          <span className="text-[var(--pd-green)]" data-id="element-14">PARA MEJORAR</span>
        </h1>

        <button type="button" onClick={scrollToBuy} className="block cursor-pointer w-full" aria-label="Ir a la sección de compra" data-id="element-15">
          <img src="https://cdn.magicpatterns.com/uploads/2qAbj38JaiYTr22V3U7KEo/ChatGPT_Image_Jun_23,_2026,_03_02_58_PM.png" alt="Padel 360 Sin Lesiones - Sistema Completo" className="w-full max-w-3xl mx-auto rounded-2xl shadow-[0_0_50px_rgba(158,255,0,0.15)] mb-8 border border-zinc-800" data-id="element-16" />
        </button>

        <h2 className="text-lg md:text-2xl text-zinc-300 font-medium max-w-3xl mx-auto mb-8 md:mb-10 leading-relaxed" data-id="element-17">
          Entrenamiento, táctica, estrategia y prevención de lesiones en un
          único sistema paso a paso.
        </h2>

        <div className="flex flex-col items-center gap-2 mb-10 text-xs sm:text-sm" data-id="element-18">
          <span className="flex items-center gap-1.5 bg-zinc-900 px-3 py-1.5 rounded-full border border-zinc-800 whitespace-nowrap" data-id="element-19">
            <BookOpen className="text-[var(--pd-green)] w-4 h-4" data-id="element-20" />
            <span className="font-bold" data-id="element-21">100% PDF</span>
          </span>
          <div className="flex flex-wrap justify-center items-center gap-2" data-id="element-22">
            <span className="flex items-center gap-1.5 bg-zinc-900 px-3 py-1.5 rounded-full border border-zinc-800 whitespace-nowrap" data-id="element-23">
              <Zap className="text-[var(--pd-green)] w-4 h-4" data-id="element-24" />
              <span className="font-bold" data-id="element-25">Entrega Inmediata</span>
            </span>
            <span className="flex items-center gap-1.5 bg-zinc-900 px-3 py-1.5 rounded-full border border-zinc-800 whitespace-nowrap" data-id="element-26">
              <ShieldCheck className="text-[var(--pd-green)] w-4 h-4" data-id="element-27" />
              <span className="font-bold" data-id="element-28">20 Módulos + 14 Bonos</span>
            </span>
          </div>
        </div>

        <ScrollButton data-id="element-29" />
      </header>

      {/* PROBLEMATICAS */}
      <section className="py-12 md:py-16 px-4 bg-zinc-950 border-y border-zinc-900" data-id="element-30">
        <div className="max-w-4xl mx-auto" data-id="element-31">
          <h2 className="text-2xl md:text-4xl font-display text-center mb-4 uppercase" data-id="element-32">
            El padel, no es solo pegarle a la pelota con la raqueta
          </h2>
          <p className="text-center text-zinc-400 mb-12 max-w-2xl mx-auto" data-id="element-33">
            Muchos jugadores y jugadoras de padel, pasan por{' '}
            <span className="text-[var(--pd-red)] font-bold" data-id="element-34">estas cosas</span>{' '}
            siempre:
          </p>

          <div className="space-y-4" data-id="element-35">
            {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-4 bg-black p-5 rounded-xl border border-red-950/30" data-id="element-36">
                <div className="bg-red-950/50 p-2 rounded-lg mt-1" data-id="element-37">
                  <AlertTriangle className="text-[var(--pd-red)] w-6 h-6 flex-shrink-0" data-id="element-38" />
                </div>
                <p className="text-base md:text-lg text-zinc-300 leading-relaxed" data-id="element-39">
                  {problem}
                </p>
              </div>)}
          </div>

          <p className="text-center text-xl md:text-3xl font-display uppercase mt-12 md:mt-14 leading-tight" data-id="element-40">
            Por esto, hicimos{' '}
            <span className="text-[var(--pd-green)]" data-id="element-41">
              Padel 360 Sin Lesiones
            </span>
          </p>
        </div>
      </section>

      {/* CONTENIDO DEL PROGRAMA */}
      <section className="py-14 md:py-20 px-4 max-w-4xl mx-auto" data-id="element-42">
        <h2 className="text-3xl md:text-5xl font-display text-center mb-10 md:mb-12 uppercase" data-id="element-43">
          ¿Qué vas a encontrar adentro?
        </h2>

        <div className="space-y-2" data-id="element-44">
          {modules.map((mod, idx) => {
          // If it's a block title (no content), render it differently
          if (mod.content.length === 0) {
            return <div key={idx} className="mt-8 md:mt-10 mb-4 bg-[var(--pd-green)] text-black p-3 md:p-4 rounded-lg font-black text-base md:text-xl uppercase tracking-wider text-center leading-tight" data-id="element-45">
                  {mod.title}
                </div>;
          }
          return <AccordionItem key={idx} title={mod.title} content={mod.content} isOpen={openModule === idx} onClick={() => toggleModule(idx)} data-id="element-46" />;
        })}
        </div>

        <div className="mt-16 text-center" data-id="element-47">
          <ScrollButton data-id="element-48" />
        </div>
      </section>

      {/* OPINIONES */}
      <section className="py-12 md:py-16 px-4 bg-zinc-950 border-y border-zinc-900" data-id="element-49">
        <div className="max-w-5xl mx-auto" data-id="element-50">
          <Testimonials data-id="element-51" />
        </div>
      </section>

      {/* BONOS */}
      <section className="py-14 md:py-20 px-4 bg-zinc-950 border-y border-zinc-900" data-id="element-52">
        <div className="max-w-4xl mx-auto" data-id="element-53">
          <p className="text-center text-base md:text-xl text-zinc-300 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-54">
            No queremos que te quedes a mitad de camino en tu cambio, por eso te
            regalamos los siguientes bonos:
          </p>
          <h2 className="text-3xl md:text-5xl font-display text-center mb-4 uppercase" data-id="element-55">
            Bonos Exclusivos
          </h2>
          <p className="text-center text-[var(--pd-green)] font-bold text-xl mb-12 uppercase tracking-wide animate-pulse" data-id="element-56">
            Estos bonos son GRATIS por el día de hoy
          </p>

          <div className="space-y-2 mb-12" data-id="element-57">
            {bonuses.map((bonus, idx) => <AccordionItem key={idx} title={bonus.title} content={bonus.content} isOpen={openBonus === idx} onClick={() => toggleBonus(idx)} data-id="element-58" />)}
          </div>

          <ComparisonTable data-id="element-59" />
        </div>
      </section>

      {/* OFERTA FINAL */}
      <section className="py-14 md:py-20 px-4 max-w-2xl mx-auto text-center" data-id="element-60">
        <div id="comprar" className="scroll-mt-8 bg-zinc-900 border-2 border-[var(--pd-green)] rounded-2xl p-5 sm:p-6 md:p-10 relative overflow-hidden shadow-[0_0_50px_rgba(158,255,0,0.1)]" data-id="element-61">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-transparent via-[var(--pd-green)] to-transparent opacity-50" data-id="element-62"></div>

          <h2 className="text-3xl md:text-4xl font-display uppercase mb-6" data-id="element-63">
            Acceso Completo + Bonos
          </h2>

          {/* Resumen compacto de la oferta */}
          <ul className="text-left max-w-sm mx-auto space-y-2 mb-8" data-id="element-64">
            {['20 Tomos del sistema completo', '5 Bonos exclusivos (GRATIS hoy)', '100% PDF · Entrega inmediata', 'Acceso de por vida + actualizaciones'].map(item => <li key={item} className="flex items-center gap-3 text-zinc-200" data-id="element-65">
                <CheckCircle2 className="w-5 h-5 text-[var(--pd-green)] flex-shrink-0" data-id="element-66" />
                <span className="font-medium" data-id="element-67">{item}</span>
              </li>)}
          </ul>

          {/* Reloj + cupos unificados */}
          <Countdown data-id="element-68" />

          <div className="flex flex-col items-center justify-center mb-6" data-id="element-69">
            <span className="text-zinc-500 line-through text-xl font-bold" data-id="element-70">
              $82,990.00
            </span>
            <div className="flex items-start text-[var(--pd-green)]" data-id="element-71">
              <span className="text-2xl font-bold mt-2" data-id="element-72">$</span>
              <span className="text-6xl font-black font-display tracking-tighter" data-id="element-73">
                23,990
              </span>
            </div>
            <span className="text-xs text-zinc-400 mt-1 uppercase font-bold tracking-widest" data-id="element-74">
              Pago Único
            </span>
          </div>

          <BuyButton className="mb-4" data-id="element-75" />

          <div className="flex justify-center items-center gap-2 text-sm text-zinc-400" data-id="element-76">
            <ShieldCheck className="w-4 h-4" data-id="element-77" />
            <span data-id="element-78">Pago 100% Seguro y Encriptado</span>
          </div>
        </div>
      </section>

      {/* FAQ & SUPPORT */}
      <section className="py-12 md:py-16 px-4 bg-zinc-950 border-t border-zinc-900" data-id="element-79">
        <div className="max-w-3xl mx-auto" data-id="element-80">
          <h2 className="text-2xl md:text-3xl font-display text-center mb-8 md:mb-10 uppercase" data-id="element-81">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-6 mb-16" data-id="element-82">
            {objections.map((obj, idx) => <div key={idx} className="bg-black p-6 rounded-xl border border-zinc-800" data-id="element-83">
                <h3 className="text-xl font-bold text-white mb-3 flex items-start gap-3" data-id="element-84">
                  <span className="text-[var(--pd-green)] mt-1" data-id="element-85">?</span>
                  {obj.q}
                </h3>
                <p className="text-zinc-400 leading-relaxed pl-6" data-id="element-86">{obj.a}</p>
              </div>)}
          </div>

          <div className="text-center flex flex-col items-center justify-center border-t border-zinc-800 pt-12" data-id="element-87">
            <Settings className="w-12 h-12 text-zinc-600 mb-4 animate-[spin_10s_linear_infinite]" data-id="element-88" />
            <h3 className="text-xl font-bold mb-2" data-id="element-89">¿Necesitás ayuda?</h3>
            <p className="text-zinc-400 mb-4" data-id="element-90">
              Contactá a nuestro equipo de soporte
            </p>
            <a href="mailto:EbookDreamShop@gmail.com" className="text-[var(--pd-green)] font-bold hover:underline text-lg" data-id="element-91">
              EbookDreamShop@gmail.com
            </a>
          </div>
        </div>
      </section>
    </div>;
}